export default __webpack_public_path__ + "static/199-367c935b98080c470bbb5eff9c4c5fe2.jpg";